import { AppBar, Toolbar, Typography, Box } from '@mui/material';

export default function Header() {
  return (
    <AppBar position="static" sx={{ mb: 4, backgroundColor: '#aa5417' }}>
      <Toolbar>
        <Box display="flex" alignItems="center" flexGrow={1}>
          <img
            src="/logo-white.png"
            alt="Rough Creek Lodge"
            height={40}
            style={{ marginRight: 16 }}
          />
          <Typography variant="h6" component="div">
            Guest Feedback
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
